import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderProgress extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
        this.cssClasses = {
            col: 'col-8 -xl-half -s-full -mb4',
            resourceBox: 'Elevated -full -pr -bg-white -br2',
            resourceWrapper: 'ResourceItem',
            resourceImage: 'ResourceItem-image Section-bg',
            resourceLabel: 'ResourceLabel -mb0 -pa -l0 -b0 -z1',
            resourceContent: 'ResourceItem-info',
            resourceData: 'ResourceItem-hint -cf',
            resourceTitle: 'ResourceItem-title -mb0',
        }
    }

    getItemHtml(item, relatedMedia) {
        let { col, resourceBox, resourceWrapper, resourceImage, resourceLabel, resourceContent, resourceData, resourceTitle} = this.cssClasses;
        let { imageData } = super.setRelatedMedia(item, relatedMedia);
        let webinarLabel = '';
        let startDate = '';
        let startTime = '';
        let resourceUrl = '';
        const { Title, UrlName: resourcePath } = item;
        const contentType = item.resourceCategory[0];
        if(item.CTAUrl){
            resourceUrl = item.CTAUrl;
        }
        else {
            const pageUrl = super.getResourceUrl(item.contenttypes[0]);
            resourceUrl = `${pageUrl}/${resourcePath}`;
        }

        switch(contentType.Id)
        {
            case '7504a528-711e-45b6-b299-1ec0be7d1852': // webinars
                if (item.IsUpcomming) {
                    var date = new Date(item.StartDate);
                    var localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
                    startDate = localDate.toLocaleDateString('en-us', { year: 'numeric', month: 'long', day: 'numeric' });
                    startTime = localDate.toLocaleTimeString('en-us', { hour: '2-digit', minute: '2-digit', hour12: true });
                    startTime += ' ';
                    var timeZone = /\((.*)\)/.exec(new Date().toString())[1];
                    var timeZoneParts = timeZone.split(' ');
                    for (var part of timeZoneParts) {
                        startTime += part[0]
                    }
                } 
                else {
                    webinarLabel = 'On-Demand';
                }
                resourceLabel += ' ResourceLabel--webinar';
                break;
            case 'e9a8019e-107a-45f5-bdcf-bfaab9ba7ddb': // videos
                if (!imageData || !imageData.Url) {
                    imageData = { Url: "https://img.youtube.com/vi/" + item.YouTubeId + "/mqdefault.jpg", AlternativeText: "default video thumbnail" };
                }

                resourceLabel += ' ResourceLabel--video';
                break;
            case 'e1399bf0-90d5-4cee-94ff-88910fb5d017': // best practices
                resourceLabel += ' ResourceLabel--bestPractices';
                break;
            default:
                resourceLabel += ' ResourceLabel--paper';
        }

        if (!imageData || !imageData.Url) {
            imageData = this.getDefaultThumbnail(contentType.Id);
        }

        const html = `
        <div class="${col}">
            <div class="${resourceBox}">
                <a href="${resourceUrl}" class="-full -mh100">
                    <div class="${resourceWrapper}">

                        <div class="${resourceImage}">
                            <img src="${imageData.Url}" alt="${imageData.AlternativeText}">
                            <p class="${resourceLabel}">${contentType.Title}</p>
                        </div>
                        <div class="${resourceContent}">
                            <div class="${resourceData}">
                                ${webinarLabel ? webinarLabel : ''}
                                ${!item.Duration ? '&nbsp;' : `${item.Duration}`}
                                ${startDate || startTime ? `<span class="-fl">${startDate}</span><span class="-fr">${startTime}</span>` : '&nbsp;'}
                            </div>
                            <h4 class="${resourceTitle}">${this.encodeHtml(Title)}</h4>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        `;

        return html;
    }

    getDefaultThumbnail(contentTypeId) {
        switch(contentTypeId) {
            case '7504a528-711e-45b6-b299-1ec0be7d1852': // webinars
                return {
                    Url: 'https://d117h1jjiq768j.cloudfront.net/images/default-source/resource-center/webinar/webinar-3-thumbnail.svg?v=2',
                    AlternativeText: 'default webinar thumbnail'
                };
            case 'aed1dd6e-7af4-4570-8852-3547d70331e9': // whitepapers
                return {
                    Url: 'https://d117h1jjiq768j.cloudfront.net/images/default-source/resource-center/paper/whitepaper-3-thumbnail.svg?v=2',
                    AlternativeText: 'default whitepaper thumbnail'
                };
            case '8f53db76-b462-4053-8318-cda7745a693f': // ebooks
                return {
                    Url: 'https://d117h1jjiq768j.cloudfront.net/images/default-source/resource-center/ebook/ebook-2-thumbnail.svg?v=2',
                    AlternativeText: 'default ebook thumbnail'
                };
            case 'b1923938-abe4-4fca-9453-bf0ce38e5cd6': // infographics
                return {
                    Url: 'https://d117h1jjiq768j.cloudfront.net/images/default-source/resource-center/infographic/infographic-1-thumbnail.svg?v=2',
                    AlternativeText: 'default infographic thumbnail'
                };
            case '8d749b3c-ac2b-4f6d-b89c-beafdaff5ac0': // datasheets
                return {
                    Url: 'https://d117h1jjiq768j.cloudfront.net/images/default-source/resource-center/datasheet/datasheet-3-thumbnail.svg?v=2',
                    AlternativeText: 'default datasheet thumbnail'
                };
            case 'ab7b1452-1e5e-4f01-9bdf-ed2e84809561': // reports
                return {
                    Url: 'https://d117h1jjiq768j.cloudfront.net/images/default-source/resource-center/report/report-2-thumbnail.svg?v=2',
                    AlternativeText: 'default report thumbnail'
                };
            case 'e1399bf0-90d5-4cee-94ff-88910fb5d017': // best practices
                return {
                    Url: 'https://d117h1jjiq768j.cloudfront.net/images/default-source/resource-center/best-practice/best-practices-1-thumbnail.svg?v=2',
                    AlternativeText: 'default best practice thumbnail'
                };
            default:
                return {
                    Url: 'https://d117h1jjiq768j.cloudfront.net/images/default-source/resource-center/paper/whitepaper-3-thumbnail.svg?v=2',
                    AlternativeText: 'default resource thumbnail'
                };
        }
    }

    getDate(utcDate){
        let date = new Date(utcDate);
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    }
}
